module.exports = __webpack_public_path__ + "static/media/rejected-booking-icon.a10931e2.svg";